import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const EditDesign16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M2.46087 2C1.65405 2 1 2.64991 1 3.45161V5.14516V13.0484C1 13.8501 1.65405 14.5 2.46087 14.5H13.5391C14.3459 14.5 15 13.8501 15 13.0484V5.14516V3.45161C15 2.64991 14.3459 2 13.5391 2H2.46087ZM2.46087 3.20968C2.3264 3.20968 2.21739 3.318 2.21739 3.45161V4.54032H13.7826V3.45161C13.7826 3.318 13.6736 3.20968 13.5391 3.20968H2.46087ZM2.21739 13.0484C2.21739 13.182 2.3264 13.2903 2.46087 13.2903H13.5391C13.6736 13.2903 13.7826 13.182 13.7826 13.0484V5.75H2.21739V13.0484Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M4.02319 6.375C3.45169 6.375 2.98841 6.83535 2.98841 7.40323V9.37903C2.98841 9.94691 3.45169 10.4073 4.02319 10.4073H6.29565C6.86715 10.4073 7.33043 9.94691 7.33043 9.37903V7.40323C7.33043 6.83535 6.86715 6.375 6.29565 6.375H4.02319ZM4.2058 7.58468V9.19758H6.11304V7.58468H4.2058Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M3.5971 11.1734C3.26093 11.1734 2.98841 11.4442 2.98841 11.7782C2.98841 12.1123 3.26093 12.3831 3.5971 12.3831H6.72174C7.05791 12.3831 7.33043 12.1123 7.33043 11.7782C7.33043 11.4442 7.05791 11.1734 6.72174 11.1734H3.5971Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M9.42029 6.375C8.84879 6.375 8.38551 6.83535 8.38551 7.40323V9.37903V11.3548C8.38551 11.9227 8.84879 12.3831 9.42029 12.3831H11.9768C12.5483 12.3831 13.0116 11.9227 13.0116 11.3548V9.37903V7.40323C13.0116 6.83535 12.5483 6.375 11.9768 6.375H9.42029ZM9.6029 7.58468H11.7942V8.77419H9.6029V7.58468ZM9.6029 11.1734H11.7942V9.98387H9.6029V11.1734Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
